import { render, staticRenderFns } from "./CodeBarReader.vue?vue&type=template&id=021449e9"
import script from "./CodeBarReader.vue?vue&type=script&lang=js"
export * from "./CodeBarReader.vue?vue&type=script&lang=js"
import style0 from "./CodeBarReader.vue?vue&type=style&index=0&id=021449e9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports